module.exports = __webpack_public_path__ + "static/media/rest3.a0aa120d.png";